<template>
  <login-page
    :warn-explorer="$attrs['warn-explorer']"
    :error="errorCode"
    :is-loading="isLoading"
    :account-slug="config.slug || ''"
    :config-logo="configSignIn.logo"
    :companies-selection="companiesSelection"
    @submit="submit"
    @clear-error="clearError"
  />
</template>

<script>
import { CONFIG_MAIN, CONFIG_SIGNIN, AUTH_LOGIN, AUTH_LOGIN_GENERIC_APP, AUTH_CREDENTIALS } from '@store/types'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import LoginPage from '@components/Login/LoginPage'

const errorCodes =
{
  '-1': { type: '', data: {} },
  0: { type: 'inactiveCompany', data: {} },
  1: { type: 'invalidCredentials', data: {} },
  2: { type: 'userNotFound', data: {} },
  3: { type: 'notEnabled', data: {} },
  4: { type: 'notActive', data: {} },
  5: { type: 'invalidPassword', data: {} },
  6: { type: 'inactiveAccount', data: {} }
}

export default {
  components: { LoginPage },

  data () {
    return {
      errorCode: errorCodes['-1'],
      isLoading: false,
      companiesSelection: {}
    }
  },

  computed: {
    ...mapGetters({
      config: CONFIG_MAIN,
      configSignIn: CONFIG_SIGNIN
    })
  },

  methods: {
    ...mapActions({
      login: AUTH_LOGIN,
      genericLogin: AUTH_LOGIN_GENERIC_APP
    }),
    ...mapMutations({
      auth_credentials: AUTH_CREDENTIALS
    }),
    async submit (userData) {
      if ((this.config || {}).generic_app) {
        const response = await this.genericLogin(userData)

        if (typeof response === 'number') {
          this.errorCode = errorCodes[response]
          this.companiesSelection = {}
        } else {
          this.companiesSelection = { ...response }
        }
      } else {
        this.isLoading = true

        const { token, data = {}, activate = false } = await this.login(userData)
        if (activate) {
          this.auth_credentials({ ...data, ...userData })
          this.$router.push({ name: 'Formulário de ativação' })
        } else {
          const redirectTo = !this.$route.query.redirectTo || this.$route.query.redirectTo.match('\/undefined')
            ? { name: 'Home' }
            : this.$route.query.redirectTo

          if (token) {
            this.$router.push(redirectTo)

            window.dataLayer.push({
              event: 'Logins'
            })
          } else {
            this.errorCode = errorCodes[data.error]
            if (this.errorCode && this.errorCode.data) this.errorCode.data = data
          }
        }

        this.isLoading = false
      }
    },

    clearError () {
      this.errorCode = errorCodes['-1']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Login/LoginPage.vue